import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { RedirectToExternalBankErrorComponent } from './redirect-to-external-bank-error.component';

@NgModule({
  declarations: [RedirectToExternalBankErrorComponent],
  imports: [CommonModule, SharedModule],
  exports: [RedirectToExternalBankErrorComponent],
})
export class RedirectToExternalBankErrorModule {}
